import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { debugLogPages } from "../helpers/debugHelper";

export const PublicRoute7 = ({ children }) => {
  debugLogPages(':: PublicRoute7');
  const { isUserAuthenticated } = useSelector((state) => state.auth);
  return !isUserAuthenticated ? children : <Navigate to="/dashboard" />;
};
